import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { Solutions } from './pages/Solutions';
import { Products } from './pages/Products';
import { CaseStudies } from './pages/CaseStudies';
import { Pricing } from './pages/Pricing';
import { Resources } from './pages/Resources';
import { Consultation } from './pages/Consultation';
import { ThankYou } from './pages/ThankYou';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { queryClient } from './lib/queryClient';
import { SEO } from './components/SEO';

const App = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <AuthProvider>
            <AnalyticsProvider>
              <Router>
                <SEO />
                <main className="relative min-h-screen bg-background text-white overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-b from-background-light to-background-dark" />
                  <Navigation />
                  <div className="relative">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/solutions/*" element={<Solutions />} />
                      <Route path="/products/*" element={<Products />} />
                      <Route path="/case-studies/*" element={<CaseStudies />} />
                      <Route path="/pricing" element={<Pricing />} />
                      <Route path="/resources" element={<Resources />} />
                      <Route path="/consultation" element={<Consultation />} />
                      <Route path="/thank-you" element={<ThankYou />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/dashboard" element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      } />
                    </Routes>
                  </div>
                </main>
              </Router>
            </AnalyticsProvider>
          </AuthProvider>
        </ErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;